import Component from "./treasures"
export default Component
